import { Selector } from "@ngxs/store";
import { AuthState, AuthStateModel } from "./auth.state";
import { Profile, Unit } from "@app/models/profile.model";

export class AuthSelectors {
    @Selector([AuthState])
    static accessToken(state: AuthStateModel): string | null {
        return state.accessToken;
    }

    @Selector([AuthState])
    static refreshToken(state: AuthStateModel): string | null {
        return state.refreshToken;
    }

    @Selector([AuthState])
    static profile(state: AuthStateModel): Profile | null {
        return state.profile;
    }

    @Selector([AuthState])
    static unitList(state: AuthStateModel): Unit[] {
        return state.profile?.unitList ?? [];
    }

    @Selector([AuthState])
    static selectedUnit(state: AuthStateModel): Unit | null {
        return state.profile?.selectedUnit ?? null;
    }

    @Selector([AuthState])
    static objectcd(state: AuthStateModel): string {
        const selectedUnit = state.profile?.selectedUnit;
        if (selectedUnit) {
            const { organizationCode, companyCode, blockCode, code } = selectedUnit;
            return `${organizationCode}${companyCode}${blockCode}00${code}`;
        }
        return '';
    }
}